import fetchSrcmAPIDecompose from "./fetchSrcmAPIDecompose";

export const SESSION_EXPIRED_MESSAGE =
  "Session expired. Please refresh page and continue!";

const stringify = (v) => (typeof v === "string" ? v : JSON.stringify(v));
const transformErrorString = (apiError) =>
  Object.values(JSON.parse(apiError))
    .map((v) => (Array.isArray(v) ? v.join(", ") : stringify(v)))
    .join(", ");

//  const errorAsString = (apiError) => !apiError.startsWith("Error: ")
// ? apiError
// : transformErrorString(apiError.replace("Error: ", ""));

export default function fetchSrcmAPI(
  api,
  authToken = "",
  method = "GET",
  extraHdrs = {},
  extraData = {},
  forceAuth = false,
  methodParams = {},
  client = "baseClient"
) {
  const [url, data, retHandler] = fetchSrcmAPIDecompose(
    api,
    authToken,
    method,
    extraHdrs,
    extraData,
    forceAuth,
    methodParams,
    client
  );
  const loginType = localStorage.getItem("loginType");
  const executeFetch = () =>
    fetch(url, data).then((res) => {
      if (!res.ok) {
        return res.text().then((text) => {
          if (
            text ===
            '{"detail":"Authentication credentials were not provided."}'
          ) {
            throw new Error(SESSION_EXPIRED_MESSAGE);
          }
          throw new Error(transformErrorString(text));
        });
      }

      if (method === "DELETE") return true;
      if (retHandler === "json") return res.json();
      if (retHandler === "text") return res.text();
      return res.json();
    });

  return executeFetch().catch((err) => {
    if (err.message === SESSION_EXPIRED_MESSAGE && loginType === "mobileApp") {
      const refreshOverlay = document.createElement("div");
      refreshOverlay.style.position = "fixed";
      refreshOverlay.style.top = "0";
      refreshOverlay.style.left = "0";
      refreshOverlay.style.width = "100%";
      refreshOverlay.style.height = "100%";
      refreshOverlay.style.display = "flex";
      refreshOverlay.style.justifyContent = "center";
      refreshOverlay.style.alignItems = "center";
      refreshOverlay.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
      refreshOverlay.style.zIndex = "9999";
      refreshOverlay.style.color = "#fff";
      refreshOverlay.style.fontSize = "20px";
      refreshOverlay.innerText = "Session is refreshing...";
      document.body.appendChild(refreshOverlay);

      const removeOverlay = () => {
        if (document.body.contains(refreshOverlay)) {
          document.body.removeChild(refreshOverlay);
        }
      };
      if (
        window.ReactNativeWebView &&
        typeof window.ReactNativeWebView.postMessage === "function"
      ) {
        window.ReactNativeWebView.postMessage("EXPIRED_TOKEN");
      }
      return new Promise((resolve, reject) => {
        const listener = (message) => {
          try {
            if (message.data && message.data.token) {
              window.removeEventListener("message", listener);
              const newAuthToken = message.data.token;
              const [retryUrl, retryData, retryRetHandler] =
                fetchSrcmAPIDecompose(
                  api,
                  newAuthToken,
                  method,
                  extraHdrs,
                  extraData,
                  forceAuth,
                  methodParams,
                  client
                );
              fetch(retryUrl, retryData)
                .then((retryRes) => {
                  if (!retryRes.ok) {
                    return retryRes.text().then((retryText) => {
                      reject(new Error(transformErrorString(retryText)));
                    });
                  }
                  if (method === "DELETE")
                    return resolve({ data: true, token: newAuthToken });
                  if (retryRetHandler === "text") {
                    return retryRes
                      .text()
                      .then((text) =>
                        resolve({ data: text, token: newAuthToken })
                      );
                  }
                  return retryRes.json().then((json) => {
                    if (json && Array.isArray(json.results)) {
                      let pstate = localStorage.getItem("pstate");
                      const d = new Date();
                      d.setHours(d.getHours() + 8);
                      const ts = d.valueOf();
                      pstate = pstate ? JSON.parse(pstate) : {};
                      pstate = {
                        ...pstate,
                        srcmtoken: {
                          ...pstate.srcmtoken,
                          ts,
                          token: newAuthToken,
                        },
                      };
                      localStorage.setItem("pstate", JSON.stringify(pstate));
                      const updatedJson = {
                        ...json,
                        results: json.results.map((item) => ({
                          ...item,
                          token: newAuthToken,
                        })),
                      };
                      resolve(updatedJson);
                      removeOverlay();
                    }
                    resolve(json);
                  });
                })
                .catch(reject);
            }
          } catch (error) {
            reject(error);
          }
        };

        window.addEventListener("message", listener);
        setTimeout(() => {
          window.removeEventListener("message", listener);
          reject(new Error(SESSION_EXPIRED_MESSAGE));
          removeOverlay();
        }, 10000);
      });
    }
    throw err;
  });
}
